import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UserSidebar from "./UserSidebar";
import UserHeader from "./UserHeader";
import { apiFetch } from "../api_call";
import "./Dashboard.css";

export default function FinalEditGrievance() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    grv_id: "",
    grievance_name: "",
    start_date: "",
    end_date: "",
    description: "",
    action_date: "",
    reminder_days: 1,
    escalation_email: "",
    escalation_reminder_days: "",
  });

  const [successMsg, setSuccessMsg] = useState("");
  const [errors, setErrors] = useState({});
  const [errorVisible, setErrorVisible] = useState(false);
  const [successVisible, setSuccessVisible] = useState(false);

  // 🔹 Format DD-MM-YYYY → YYYY-MM-DD
  const toInputDate = (dateStr) => {
    if (!dateStr) return "";
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
    const [dd, mm, yyyy] = dateStr.split("-");
    return `${yyyy}-${mm}-${dd}`;
  };

  // 🔹 Format YYYY-MM-DD → DD-MM-YYYY
  const toAPIDate = (dateStr) => {
    if (!dateStr) return "";
    const [yyyy, mm, dd] = dateStr.split("-");
    return `${dd}-${mm}-${yyyy}`;
  };

  // 🔥 FIXED: Use RAW API DATA properly
  useEffect(() => {
    const stored = localStorage.getItem("grvEditData");
    if (!stored) return;

    const row = JSON.parse(stored);

    setFormData({
      grv_id: row.grv_id || "",

      grievance_name:
        row.grv_title ||
        row.grv_particular ||
        row.grv_act ||
        "",

      start_date: toInputDate(row.grv_start_date),
      end_date: toInputDate(row.grv_end_date),

      description:
        row.grv_description ||
        row.grv_long_description ||
        "",

      action_date: toInputDate(row.grv_action_date),

      reminder_days: Number(row.grv_reminder_days || 1),

      escalation_email: row.grv_escalation_email || "",

      escalation_reminder_days:
        row.grv_escalation_reminder_days || "",
    });
  }, []);

  // 🔹 Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors({});
    setSuccessMsg("");
  };

  // 🔹 Submit edit
  const handleSubmit = async (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });

    const grvId = localStorage.getItem("grvId");
    if (!grvId) {
      setErrors({ api: "Grievance ID missing" });
      return;
    }

    const payload = {
      grv_action_date: toAPIDate(formData.action_date),
      grv_reminder_days: Number(formData.reminder_days),
      grv_escalation_email: formData.escalation_email || null,
      grv_escalation_reminder_days:
        formData.escalation_reminder_days !== ""
          ? Number(formData.escalation_reminder_days)
          : 0,
    };

    try {
      const res = await apiFetch(`/grievance/edit/custom/${grvId}`, {
        method: "PUT",
        body: JSON.stringify(payload),
      });

      if (res?.message === "Custom grievance updated successfully") {
        setSuccessMsg("✅ Grievance updated successfully");

        setTimeout(() => {
          navigate("/edit-grievance");
        }, 1000);
      } else {
        setErrors({ api: "❌ Update failed" });
      }
    } catch (err) {
      console.error("Update error:", err);
      setErrors({
        api: err?.error || "❌ Only pending grievances can be edited",
      });
    }
  };

  // 🔹 Auto-hide error
  useEffect(() => {
    if (errors.api) {
      setErrorVisible(true);
      const timer = setTimeout(() => setErrorVisible(false), 4500);
      const removeTimer = setTimeout(() => setErrors({}), 5000);
      return () => {
        clearTimeout(timer);
        clearTimeout(removeTimer);
      };
    }
  }, [errors.api]);

  // 🔹 Auto-hide success
  useEffect(() => {
    if (successMsg) {
      setSuccessVisible(true);
      const timer = setTimeout(() => setSuccessVisible(false), 4500);
      const removeTimer = setTimeout(() => setSuccessMsg(""), 5000);
      return () => {
        clearTimeout(timer);
        clearTimeout(removeTimer);
      };
    }
  }, [successMsg]);

  return (
    <div className="add-user">
      <UserSidebar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <UserHeader menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

      <div className="form-container">
        <h2>Edit Grievance</h2>

        <div
          className="messages-top"
          style={{ margin: "0 auto 1rem auto", width: "50%" }}
        >
          {errors.api && (
            <div className={`login-error ${!errorVisible ? "fade-out" : ""}`}>
              {errors.api}
            </div>
          )}
          {successMsg && (
            <div
              className={`success-msg ${!successVisible ? "fade-out" : ""}`}
            >
              {successMsg}
            </div>
          )}
        </div>

        <form onSubmit={handleSubmit} className="add-user-form">
          <label>
            Grievance ID
            <input type="text" value={formData.grv_id} disabled />
          </label>

          <label>
            Grievance Name
            <input type="text" value={formData.grievance_name} disabled />
          </label>

          <label>
            Start Date
            <input type="date" value={formData.start_date} disabled />
          </label>

          <label>
            End Date
            <input type="date" value={formData.end_date} disabled />
          </label>

          <label>
            Description
            <textarea value={formData.description} disabled rows={3} />
          </label>

          <label>
            Action Date
            <input
              type="date"
              name="action_date"
              value={formData.action_date}
              onChange={handleInputChange}
            />
          </label>

          <label>
            Reminder Days
            <input
              type="number"
              name="reminder_days"
              min="1"
              value={formData.reminder_days}
              onChange={handleInputChange}
              style={{ width: "80px" }}
            />
          </label><label></label>

          <label>
            Escalation Email
            <input
              type="email"
              name="escalation_email"
              value={formData.escalation_email}
              onChange={handleInputChange}
            />
          </label>

          <label>
            Escalation Reminder Days
            <input
              type="number"
              name="escalation_reminder_days"
              value={formData.escalation_reminder_days}
              onChange={handleInputChange}
            />
          </label>

          <button type="submit" className="submit-btn">
            Update Grievance
          </button>
        </form>
      </div>
    </div>
  );
}